import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import TkInsertStandardUnitPriceExcelUploadButton from "../input/TkInsertStandardUnitPriceExcelUploadButton";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import TkInsertStandardUnitPriceSearchButton from "../input/TkInsertStandardUnitPriceSearchButton";

function TkInsertStandardUnitPrice ( props ) {

    const id = "TkInsertStandardUnitPrice"

    const table = "TkInsertStandardUnitPrice"

    const view = "TkVwInsertStandardUnitPrice"

    const [schema, setSchema] = useState();

    const [mstApi, setMstApi] = useState();

    const [grid, setGrid] = useState();

    const [isEmpty, setIsEmpty] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(()=> {

        let mounted = true;

        (async () => {

            let schema = await getSchema(table);
            if ( mounted ) {
                setSchema(schema);
            }

        })();

        return ( () => {
            mounted = false;
        } );

    },[]);

    const onApiInitialized = (api) => {

        setMstApi(api);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const onInitialized = grid => {

        setGrid(grid);

    };


    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

    return (
        <BasicCrudScreenType 
            id={id}
            table={table}
            view={view}
            onApiInitialized = {onApiInitialized}
            onInitialized={onInitialized}
            onLoadData={onLoadData}
            noCreate
            noEdit
            noDelete
            noExcel
            onAppendButtonInFrontOfSearch={
                () => (
                    <>
                        <BasicCrudScreenActionItemLayout>
                        <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                            <CreateRecordButton
                                id={id}
                                schema={schema}
                                refresh={mstApi}
                                onSuccess={onSuccess}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch ? "PATCH" : "PUT")}>
                            <UpdateRecordButton
                                id={id}
                                schema={schema}
                                grid={grid}
                                refresh={mstApi}
                                disabled={isEmpty}
                                onSuccess={onSuccess}
                            />
                        </AccessControl>

                            <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                                <DeleteRecordButton
                                    id={id}
                                    schema={schema}
                                    grid={grid}
                                    refresh={mstApi}
                                    color="secondary"
                                    disabled={isEmpty}
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                />
                            </AccessControl>
                            <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                <TkInsertStandardUnitPriceExcelUploadButton
                                    createButtonName={"createWithExcel"}
                                    id={id}
                                    schema={schema}
                                    refresh={mstApi}
                                    onSuccess={onSuccess}
                                    modifyUrlCallback={(url) => `${url}?excel`}
                                />
                            </AccessControl>
                            <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                <TkInsertStandardUnitPriceSearchButton
                                    id={id}
                                />
                            </AccessControl>

                        </BasicCrudScreenActionItemLayout>
                    </>
                )
            }
        />
    );

}

export default TkInsertStandardUnitPrice;
